import * as type from './type';
import {get, post} from "../../../../util/api";
import * as selector from './selector';

export const savePartner = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }
    dispatch(savePartnerRequest())
    const partner = selector.selectPartner(state)

    post('/api/partner/create-update-store-partner', partner)
        .then(() => {
            dispatch(savePartnerSuccess())
            dispatch(clearState())
        })
        .catch(error => {
            dispatch(savePartnerError(error))
        });
}

export const findPartner = (partnerId) => (dispatch, getState) => {
    dispatch(findPartnerRequest())

    get('/api/partner/get-by-id?id=' + partnerId)
        .then(partner => {
            dispatch(findPartnerSuccess(partner))
        })
        .catch(error => {
            dispatch(findPartnerError(error))
        })
}

export const findPartnerRequest = () => ({
    type: type.FIND_PARTNER_REQUEST,
});

export const findPartnerSuccess = (partner) => ({
    type: type.FIND_PARTNER_SUCCESS,
    payload: {
        partner
    },
});

export const findPartnerError = (error) => ({
    type: type.FIND_PARTNER_ERROR,
    payload: {
        error:error
    },
});

export const savePartnerRequest = () => ({
    type: type.SAVE_PARTNER_REQUEST,
});

export const savePartnerSuccess = () => ({
    type: type.SAVE_PARTNER_SUCCESS,
});

export const clearState = () => ({
    type: type.CLEAR_STATE,
})

export const savePartnerError = (error) => ({
    type: type.SAVE_PARTNER_ERROR,
    payload: {
        error
    },
});

export const editPartnerFormValue = (name, value) => ({
    type: type.EDIT_PARTNER,
    payload: {
        name,
        value,
    },
});

export const pushValidationList = (list) => ({
    type: type.VALIDATION_LIST,
    payload: {
        list
    },
});


// WEBPACK FOOTER //
// ./src/modules/partner/state/detail/action.js